var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.501,
    height: 38,
    viewBox: "0 0 34.501 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_64",
    x: 0,
    y: 0,
    width: 32.681,
    height: 38,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_65",
    x: 16.98,
    y: 21.055,
    width: 17.522,
    height: 16.944,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_28",
    "data-name": "Groupe 28",
    transform: "translate(74.9 -488.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -74.9, 488.8)",
    filter: "url(#Trac\\xE9_64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_64-2",
    "data-name": "Trac\\xE9 64",
    d: "M-57.155,488.8c.382.069.773.107,1.145.213a6.538,6.538,0,0,1,4.985,5.285,6.5,6.5,0,0,1-2.282,6.45c-.085.075-.173.146-.265.223.589.257,1.168.482,1.723.757a12.819,12.819,0,0,1,4.951,4.354.982.982,0,0,1-.236,1.37.969.969,0,0,1-1.371-.219,12.6,12.6,0,0,0-1.922-2.178,10.828,10.828,0,0,0-5.8-2.621l-.4-.05c.1.479.2.929.3,1.378.522,2.371,1.04,4.743,1.571,7.112a1.2,1.2,0,0,1-.361,1.217c-.6.578-1.175,1.172-1.762,1.758a1.025,1.025,0,0,1-1.627-.007c-.588-.586-1.167-1.18-1.762-1.758a1.2,1.2,0,0,1-.353-1.219q.919-4.112,1.817-8.228c.015-.07.02-.143.032-.231a10.11,10.11,0,0,0-2.62.6,11,11,0,0,0-5.167,3.935,10.717,10.717,0,0,0-1.807,4.111,1.024,1.024,0,0,0,1.063,1.246c1.021.008,2.041,0,3.062,0,.4,0,.8-.005,1.195,0a1,1,0,0,1,1.024,1,.99.99,0,0,1-1.028.992c-1.452.006-2.9.015-4.357,0a3,3,0,0,1-2.93-2.5.881.881,0,0,0-.049-.136v-.747c.135-.511.242-1.03.409-1.53a12.861,12.861,0,0,1,7.056-7.9c.388-.18.794-.323,1.193-.484a.255.255,0,0,0-.032-.053c-.068-.06-.139-.118-.207-.179a6.5,6.5,0,0,1-2.3-6.465,6.538,6.538,0,0,1,4.984-5.283c.372-.106.762-.144,1.144-.213Zm4.282,6.775a4.8,4.8,0,0,0-4.783-4.782,4.8,4.8,0,0,0-4.776,4.789,4.79,4.79,0,0,0,4.721,4.766A4.788,4.788,0,0,0-52.873,495.575Zm-4.8,11.4-.058,0q-.425,1.926-.847,3.852a.226.226,0,0,0,.044.176c.264.283.535.559.821.854.282-.284.528-.541.785-.785a.3.3,0,0,0,.088-.327c-.135-.572-.252-1.148-.378-1.722Q-57.445,508-57.674,506.972Z",
    transform: "translate(74.9 -488.8)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -74.9, 488.8)",
    filter: "url(#Trac\\xE9_65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_65-2",
    "data-name": "Trac\\xE9 65",
    d: "M205.712,831.505c-.78,0-1.56.008-2.34,0a.987.987,0,0,1-.378-1.893,1.5,1.5,0,0,1,.533-.091c1.394-.007,2.788,0,4.181,0a1.051,1.051,0,0,0,1.178-1.325,1,1,0,0,1,1.964-.317,3.023,3.023,0,0,1-2.8,3.624c-.779.03-1.56,0-2.339,0Z",
    transform: "translate(-180.92 -806.01)",
    fill: "#50b2dc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertIcon);
export default __webpack_public_path__ + "static/media/expert-icon.96650e470be04bd65437f9cc9dcbd765.svg";
export { ForwardRef as ReactComponent };